import styled from "styled-components";
export const Layer = styled.div `
  display: none;
  justify-content: center;
  align-items: center;
  margin-top: -2.875rem;
  position: absolute;
  left: -0.5rem;
  width: 2.5rem;
  height: 2rem;
  color: ${({ theme }) => theme.colors.white};
  background-color: ${({ theme }) => theme.colors.grey15};
  font-size: ${({ theme }) => theme.fontTokens.font12[0]};
  line-height: ${({ theme }) => theme.fontTokens.font12[1]};

  &:after {
    content: "";
    position: absolute;
    bottom: -0.375rem;
    left: 0.875rem;
    width: 0;
    height: 0;
    transform: rotate(360deg);
    border-style: solid;
    border-width: 0.375rem 0.375rem 0 0.375rem;
    border-color: ${({ theme }) => theme.colors.grey15} transparent transparent
      transparent;
  }
`;
